import * as React from "react";
import DemoButtons from "./Utiilities/DemoButtons";
import ImageSction1 from "../Assests/Images/Ed365/ImageSection1.png";
import Plans from "./Utiilities/Plans";
import Accordion from "./Utiilities/AccordionItem";
import SpecailButtons from "./Utiilities/SpecialButtons";
import Header from "./Header and Footer/Header";
import Footer from "./Header and Footer/Footer";
import ScrollToTop from "./Utiilities/ScrolltoTop";
import G2Badge from "./Utiilities/G2Badge";
import TabsWithImage from "./Utiilities/TabsWithImage";
import Availability from "./Utiilities/Availability";
import OurClients from "./Utiilities/OurClients";
import Integration from "./Utiilities/Integration";
import { MyContext } from "../App";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import GetOfferPage from "./Utiilities/GetOfferPage";
import CustomPlans from "./Utiilities/CustomPlans";
import Azuer from "./Utiilities/Azuer";
import OverviewCommon from "./GlobalMultiple/OverviewCommon";
import CyberSecurity from "./Utiilities/CyberSecurity";
import OverviewCommonET from "./GlobalMultiple/OverviewCommonET";
import LogoSlider from "./Utiilities/Slider";
import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
import OverviewCommonLMS365 from "./GlobalMultiple/OverviewCommonLMS365";
import { Dropdown, PrimaryButton, TextField } from "@fluentui/react";
import OverviewCommonAsset365 from "./GlobalMultiple/OverviewCommonAsset365";
import Trustedbylogo from "./GlobalMultiple/Trustedbylogo";
// import { mouseflow} from "react-mouseflow";
const logos = [
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/soc_142hvt-qc.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/compliants_tM_PrC8N0Z.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/iso_D4yJ25IRn.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/microsoft_vdp9CYFMBj.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/Best%20ROI%201_96Mf_DosK.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/medal%20(2)_JiluXJRGNl.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/Best%20support%201_IGpX8xxqe3.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/great-place_C3JVU5GXk.png",
];
function Asset365() {

    //GTM
    const script = document.createElement("script");
    script.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        
        gtag('consent', 'default', {
          'ad_storage': 'denied',
          'analytics_storage': 'denied',
          'functionality_storage': 'denied',
          'security_storage': 'granted',
          'wait_for_update': 500
        });
      `;
    document.head.appendChild(script);

    // React.useEffect(() => {
    //   mouseflow.initialize("d74e23c0-0490-4d54-925d-b4ea1ae7151a");
    //   }, []);
    const [ham, setHam] = React.useState(false);
    const AppName = React.useContext(MyContext);
    const [isLightboxOpen, setLightboxOpen] = React.useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = React.useState("");
    const [isVideoPlaying, setIsVideoPlaying] = React.useState(false);
    const openLightbox = (imageUrl) => {
        setSelectedImageUrl(imageUrl);
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };
    const getEmbedUrl = (url) => {
        if (url.includes("youtube.com/watch?v=")) {
            return url.replace("watch?v=", "embed/");
        } else if (url.includes("youtu.be/")) {
            const videoId = url.split("youtu.be/")[1];
            return `https://www.youtube.com/embed/${videoId}`;
        } else if (url.includes("vimeo.com/")) {
            const videoId = url.split("vimeo.com/")[1];
            return `https://player.vimeo.com/video/${videoId}`;
        } else {
            return url; // fallback for direct video links
        }
    };
    const handlePlayClick = () => {
        setIsVideoPlaying(true); // When play icon is clicked, play the video
    };
    const handleCloseVideo = () => {
        setIsVideoPlaying(false); // Close the video
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    // React.useEffect(() => {
    //   document.title = "new title"
    // }, []);
    // React.useEffect(() => {
    //   mouseflow.initialize("d74e23c0-0490-4d54-925d-b4ea1ae7151a");
    //   }, []);
    React.useEffect(() => {
        document.title = "Smarter Way to Manage Assets – Powered by Asset 365";
        const metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
            metaDescription.setAttribute(
                "content",
                "Experience seamless asset tracking and management with Apps365. From barcoding to lifecycle insights, gain complete control and maximize the value of your assets effortlessly."
            );
        } else {
            const newMeta = document.createElement("meta");
            newMeta.name = "description";
            newMeta.content = "Experience seamless asset tracking and management with Apps365. From barcoding to lifecycle insights, gain complete control and maximize the value of your assets effortlessly.";
            document.head.appendChild(newMeta);
        }
    }, []);
    // const AppName = React.useContext(MyContext);

    // const [isLightboxOpen, setLightboxOpen] = React.useState(false);
    // const [selectedImageUrl, setSelectedImageUrl] = React.useState("");

    // const openLightbox = (imageUrl) => {
    //   setSelectedImageUrl(imageUrl);
    //   setLightboxOpen(true);
    // };

    // const closeLightbox = () => {
    //   setLightboxOpen(false);
    // };

    const accordionItems = [
        {
            title: "What is Asset 365 / Asset Management 365?",
            content: `Asset 365, also known as Asset Management 365, is a Microsoft 365–based solution that helps teams organize, track, and manage all types of assets-including stock, fixed assets, and software—inside a familiar workspace. `,
        },
        {
            title: `Why is asset management important in business?`,
            content: `Asset management software is crucial for businesses as it helps track and manage both software and hardware assets. It allows employees to easily locate assets, monitor their usage, and track any changes, ensuring efficient and organized asset management across the organization.`,
        },
        {
            title: `Who can use Asset Management?`,
            content: `Any team that handles assets – IT, HR, Finance, Operations, and Administration can use it to manage assignments, inventory, software licenses, and asset lifecycles.`,
        },
        {
            title: "Can I track software licenses in Asset Management?",
            content: `Absolutely. You can monitor licenses, renewals, and usage to stay compliant and avoid duplicate costs. `,
        },
        {
            title: "Can teams access Asset 365 from mobile devices?",
            content: `Yes. Asset information, updates, and assignments can be viewed from phones or laptops, making it easy for teams to work from anywhere. `,
        },
        {
            title: "Can the SharePoint asset management system grow with my organization?",
            content: `Yes. Asset Management 365 is built to support expanding teams, increasing asset volumes, and evolving workflows without complexity. `,
        },
        {
            title: "How does AI asset management improve tracking and operations?",
            content: `AI asset management in Asset Management 365 uses intelligent features to automate asset assignments, notifications, and status updates, making tracking faster and reducing manual effort across the asset lifecycle.`,
        },
        {
            title: "Which currency are the prices listed in?",
            content: `All prices are listed in USD.`,
        },
    ];
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Asset Software - Simplify Asset Tracking &
                        Lifecycle Management</title>
                    <meta
                        name="description"
                        content="Experience seamless asset tracking and management with Apps365. From barcoding to lifecycle insights, gain complete control and maximize the value of your assets effortlessly."
                    />
                </Helmet>
                <ScrollToTop />
                <div className={`HR_MainHeaderSection HR_panelHeader`} style={{ background: "#000" }}>
                    <div className="HR_FlexCenterSpcBetween ETHR_FlexCenterSpcBetween">
                        <div className="HR_LogoSection">
                            <img
                                src={"https://ik.imagekit.io/zn4au2jftpm5/Apps365/Logos/apps365white_yKjtDjv_y.png"}
                                alt="Apps 365"
                            />
                            {""}


                            <div className="DB_button">
                                <DemoButtons StickyButton={true} getStarted={true} openDialog={true} Dialogheading={"See how Asset 365 simplifies asset tracking, reduces risk, and centralizes control within Microsoft 365"} DialogDescription={"Share your details to book your demo and our team will walk you through the platform."} />
                            </div>
                            <div>
                                <span className="MBHAMBURGER" onClick={() => setHam(!ham)}>
                                    <RxHamburgerMenu />
                                </span>
                                {/* <span className="MBHAMBURGER" onClick={() => setHam(!ham)}> ≡</span> */}
                            </div>
                        </div>

                        <div className="HR_FlexCenterSpcBetween">
                            <div
                                className="HR_navMenu ETHR_navMenu LMSNavmenu "
                                style={{ paddingLeft: "0" }}
                            >
                                <span>
                                    <ul>
                                            <img
                                            className="navheaderLogo"
                                                src={"https://ik.imagekit.io/apps365/App-Logos/Asset%20365new.png"}
                                                alt="Apps 365"
                                            />
                                            {""}
                                        <li>
                                            <a href="#Features">Features</a>
                                        </li>

                                        <li>
                                            <a href="#ClientsSpeakTestimonial">Testimonial</a>
                                        </li>
                                        <li>
                                            <a href="#Integration-ET">Integration</a>
                                        </li>
                                        <li>
                                            <a href="#pricing">Pricing</a>
                                        </li>
                                    </ul>
                                </span>
                            </div>

                            <div className="MB_button">
                                <DemoButtons StickyButton={false} getStarted={false} />
                            </div>

                            <div className="MB_button">
                                <DemoButtons StickyButton={true} getStarted={false} />
                            </div>
                        </div>
                    </div>
                </div>

                {ham ? (
                    <div
                        className="MBHB"
                        style={{
                            position: "fixed",
                            zIndex: "9",
                            top: "0vw",
                            paddingTop: "0.4vw 3vw",
                            background: "var(--panelBgColor)",
                            height: "100vh",
                        }}
                    >
                        <div className="mbflex">
                            <div className="HR_LogoSection">
                                <img
                                    src={
                                        "https://ik.imagekit.io/apps365/App-Logos/Apps365-black-logo-216x40px.png"
                                    }
                                    alt={AppName}
                                />
                                {/* <a href="https://www.apps365.com" target="_blank" rel="noreferrer">
                <img src={"https://ik.imagekit.io/apps365/App-Logos/Apps365-black-logo-216x40px.png"} alt="Apps365" />
                {""}
              </a> */}
                            </div>

                            {ham ? (
                                <div
                                    onClick={() => setHam(!ham)}
                                    style={{ margin: "12px 0px" }}
                                >
                                    <span className="cross">
                                        <RxCross1 />
                                    </span>
                                </div>
                            ) : (
                                <div onClick={() => setHam(!ham)}>
                                    <span className="cross">+</span>
                                </div>
                            )}
                        </div>
                        <div>
                            <span>
                                <ul className={`${ham ? "mbmenu" : ""}`}>
                                    <li>
                                        <div className="ET-logoIcons ET-logoIconsOnMobileView ">
                                            <img
                                                alt="MainImage"
                                                src="https://ik.imagekit.io/apps365/App-Logos/Coloured-Logos/LMS.webp"
                                            ></img>
                                            <h3 className="HR_primaryclr">Asset 365</h3>
                                        </div>
                                    </li>
                                    <li>
                                        <a href="#Features" onClick={() => setHam(false)}>
                                            Features
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#ClientsSpeakTestimonial"
                                            onClick={() => setHam(false)}
                                        >
                                            Clients
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#Integration-ET" onClick={() => setHam(false)}>
                                            Integration
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#pricing" onClick={() => setHam(false)}>
                                            Pricing
                                        </a>
                                    </li>
                                </ul>
                            </span>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {/* <Header HR365header="ET365" /> */}

                <div
                    style={{
                        backgroundColor: "unset",
                        background:
                            "linear-gradient(110deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                    }}
                >
                    <div
                        className="HR_panel"
                        style={{
                            padding: "3vw 5vw 1vw 3vw",
                            background: "linear-gradient(45deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                        }}
                    >
                        <div className="HR_FlexCenterSpcBetween HR_ParentSection1 ET365HomepageParentsection">
                            <div className="HR_Section1LeftSide LMS365-HR_Section1LeftSide">
                                <h1
                                    className="HR_primaryclr"
                                    style={{
                                        fontSize: "3vw !important",
                                        fontWeight: "800 !important",
                                        color: "#333 !important",
                                    }}
                                >
                                    Take Complete Control of Every Asset with Asset 365
                                </h1>
                                <span className="ET365-HerosectionSubheading"></span>
                                <p
                                    className="HR_textclr LMSHR_textclr" style={{ marginTop: "0.4vw" }}

                                >
                                    <p >
                                        {" "}
                                        Asset 365 enables you to track, manage, and optimize every asset directly within Microsoft 365. Monitor asset usage, status and lifecycle stages in one centralized system built for operational clarity and accountability.
                                    </p>
                                    <p >
                                        {" "}
                                        No platform switching. Just real-time visibility and control.
                                    </p>

                                </p>

                                <DemoButtons
                                    LMS365="LMS365"
                                    demobtnText="See Asset 365 Live in Action"
                                />
                            </div>
                            <div className="HR_Section1RightSide" style={{ width: "60%" }}>
                                <img
                                    className="HeroSectionImageStyles"
                                    style={{ width: "100%" }}
                                    alt="LMS 365 -Microsoft 365 Integrated LMS for Employee Training"
                                    src="https://ik.imagekit.io/apps365/Lp-pages/Asset365-Hero-Banner.webp"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                      <Trustedbylogo/>
                        <div style={{ paddingTop: "1vw" }}></div>
                        <OverviewCommonAsset365
                            MainHeading="Simplified Enterprise Asset Management Software with AI Integration"
                            MainDescription="Track and manage your assets effortlessly with our AI-powered SharePoint Asset Management system. With automated workflows and intelligent solutions, asset management is streamlined, letting you focus on growing your business."
                            MainImageAlt="ET365"
                        />
                        <div style={{ background: "linear-gradient(200deg, rgb(199 231 255 / 59%), rgb(226 208 255 / 64%), rgb(229 221 252 / 75%), rgb(217 206 236 / 67%), rgb(196 218 235 / 60%))" }}>
                            <h2
                                style={{ margin: "0px", paddingTop: "1.5vw", color: "#333" }}
                                className="HR_heading  ETHR_heading LMS_FeatureHeading"
                            >
                                AI-Powered Asset 365 Features Built for Complete Asset Visibility and Control
                            </h2>

                            <p className="AI-DescriptionStyles" style={{ margin: "0", marginBottom: "2vw", padding: "1vw 5vw" }}>
                                Asset 365 gives your organization complete control over every asset, reduces operational risk, and enhances asset lifecycle management — all within Microsoft 365.
                                <br />
                                Trusted by organizations worldwide, it standardizes asset tracking, improves accountability, maintains compliance, and eliminates the inefficiencies of manual tracking processes.


                            </p>
                            <div className="FeaturesWithImages" >
                                <div>
                                    <h2>Asset Tracking    </h2>
                                    <p className="AI-DescriptionStyles">Asset tracking ensures complete visibility and control over every asset, providing real-time insight into location, status, ownership, and utilization across your organization. Find any asset in few clicks.
                                    </p>
                                </div>
                                <div style={{ width: "57%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Lp-pages/Asset365-feature1.webp" alt="" />
                                </div>
                            </div>

                            <div className="FeaturesWithImages FeaturesWithImages1" >
                                <div>
                                    <h2>Software Asset Management   </h2>
                                    <p className="AI-DescriptionStyles">Keep software assets organized and easily monitored. Gain clear visibility into license usage, renewal dates, and overall software utilization, helping your team stay compliant and efficient.
                                    </p>
                                </div>
                                <div style={{ width: "47%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Lp-pages/Asset%20activity%20log%20banner.webp" alt="" />
                                </div>
                            </div>
                            <div className="FeaturesWithImages" >
                                <div>
                                    <h2>Complete Asset Lifecycle Management </h2>
                                    <p className="AI-DescriptionStyles">Manage the entire lifecycle of your assets—from procurement and allocation to maintenance, renewal, and retirement. Automate workflows to ensure a smooth process and prevent important steps from being overlooked.
                                    </p>
                                </div>
                                <div style={{ width: "57%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Lp-pages/Asset365-feature3.webp" alt="" />
                                </div>
                            </div>
                            <div className="FeaturesWithImages FeaturesWithImages1" >
                                <div>
                                    <h2>Asset Ownership & Allocation Tracking </h2>
                                    <p className="AI-DescriptionStyles">Assign assets to specific employees, departments, or locations and maintain full traceability to avoid misplacements. Ensure assets are always accounted for and properly managed.
                                    </p>
                                </div>
                                <div style={{ width: "47%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Lp-pages/Asset365-feature4.webp" alt="" />
                                </div>
                            </div>
                            <div class="et-feature-container LMS365FeatureCards" style={{ paddingTop: "0" }}>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/cubiclogics/Logos/Maintenance%20&%20Asset%20Lifecycle%20Tracking.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">
                                        Maintenance & Asset Lifecycle Tracking
                                    </h3>
                                    <p class="et-feature-desc">
                                        Track every asset’s lifecycle stage from purchase to disposal. Manage repairs, renewals, and upgrades to maintain optimal condition.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/cubiclogics/Logos/Assign%20and%20return%20assets%20quickly.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Assign and Return Assets Quickly</h3>
                                    <p class="et-feature-desc">
                                        Assign or reclaim assets in just a few clicks. Ensure smooth allocation and reduce workflow disruptions.
                                    </p>
                                </div>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/cubiclogics/Logos/Built%20for%20Microsoft%20365.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Built for Microsoft 365</h3>
                                    <p class="et-feature-desc">
                                        Fully integrated with Teams, Outlook, and SharePoint. Manage assets directly within the tools your team already uses.
                                    </p>
                                </div>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/cubiclogics/Logos/Asset%20Utilization%20Reports.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Asset Utilization Reports</h3>
                                    <p class="et-feature-desc">
                                        Generate clear reports on asset usage and performance. Optimize resources and make informed decisions.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/cubiclogics/Logos/Grouped%20Asset%20View.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Grouped Asset View</h3>
                                    <p class="et-feature-desc">
                                        Organize assets by category, location, or status for a clear view. Enhance visibility and streamline asset management.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/cubiclogics/Logos/Audit%20Logs.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Audit Logs</h3>
                                    <p class="et-feature-desc">
                                        Track all asset activities with detailed audit logs. Ensure transparency, accountability, and compliance.
                                    </p>
                                </div>
                                {/* <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/cubiclogics/Logos/Role-Based%20Access%20Control.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Role-Based Access Control</h3>
                                    <p class="et-feature-desc">
                                        Control who can view, edit, or manage assets, keeping sensitive data secure while fostering collaboration across departments.
                                    </p>
                                </div> */}

                            </div>
                        </div>
                        <div
                            style={{
                                padding: "3vw",
                                background: "none",
                                paddingBottom: "2vw",
                            }}
                            className="overviewsection ETOverViewSection"
                        >
                            <h2 className="HR_heading" style={{ marginBottom: "0.5vw", color: "#333", margin: "0", paddingTop: "1.5vw" }}>
                                Why Choose Asset 365
                            </h2>

                            <p className="AI-DescriptionStyles" style={{ margin: "0" }}>
                                Asset 365 simplifies asset management within Microsoft 365.
                                With built-in automation and seamless integration across Teams, Outlook, and SharePoint, it improves visibility, optimizes resource utilization, and reduces operational costs.
                            </p>
                            <p>Built for businesses of all sizes, Asset 365 minimizes manual processes, strengthens accountability, and ensures complete lifecycle management — helping your organization operate with clarity and control.</p>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "1vw 0vw" }}>
                                <DemoButtons
                                    LMS365="LMS365"
                                    demobtnText="Stay in Control of Every Asset with Asset 365"
                                />
                            </div>

                            <div
                                className="cybersection cybersectionET"
                                style={{ background: "none", paddingBottom: "1vw", paddingTop: "2vw" }}
                            >
                                <CyberSecurity PageName="ET365" />
                            </div>
                        </div>

                        <div></div>

                        <section className="sec">
                            <div>
                                <div
                                    className="easy"
                                    style={{ background: "none", padding: "0vw 5vw 3vw 5vw" }}
                                >
                                    <div className="Avilcard1 LMS_Avilcard1" >
                                        <div className="AvilcardStyle">
                                            <div className="stickerStyles">
                                                <div className="sticker">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/customer-support_wPk-OuZ23.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                            </div>
                                            <h3 className="custom" style={{ color: "#2323CE" }}>
                                                Customer Support
                                            </h3>
                                            <p className="easypera">
                                                Our support team merges technical prowess with sincere
                                                care, fostering trust through expertise and empathy.
                                                They build lasting relationships, transcending mere
                                                service to create meaningful connections.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="availcard2">
                                        <div className="cd1">
                                            <div
                                                className="c1"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon1">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/setting_z7IzKFspuo.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt1">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        {" "}
                                                        AI Enabled Apps
                                                    </h3>
                                                    <p className="easypera">
                                                        Our innovative apps are built with the options of
                                                        Azure AI, Copilot, and custom AI solutions.
                                                    </p>
                                                </div>
                                            </div>

                                            <div
                                                className="c2"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon2">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/interface%20(1)_Bn8jFsKJE.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt2">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Modern UI/UX
                                                    </h3>
                                                    <p className="easypera">
                                                        Every app is crafted using the latest Fluent UI,
                                                        ensuring seamless functionality across all devices.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cd2">
                                            <div
                                                className="c3"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon3">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/cloud-storage_wjvbbJkVt.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt3">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Swift Deployment
                                                    </h3>
                                                    <p className="easypera">
                                                        Choose any deployment
                                                        method—Teams,
                                                        Outlook, or SharePoint—that suits your preferences.
                                                    </p>
                                                    <span id="ClientsSpeakTestimonial" />
                                                </div>
                                            </div>
                                            <div
                                                className="c4"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon4">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/refresh__OBoe0tcU.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt4">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Free Updates{" "}
                                                    </h3>
                                                    <p className="easypera">
                                                        Our valued subscribers enjoy unlimited support,
                                                        enhancements, features, and updates.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>


                    <div id="client" className="IdChanges"></div>
                    <div
                        className="HR_whitesection"
                        style={{ background: "none", padding: "0vw 5vw 1vw 5vw" }}
                    >
                        <h2 className="HR_heading HR_MT" style={{ color: "#333", margin: "0" }}>Loved by teams. Trusted by leaders worldwide</h2>
                        <p class="et-integration-subtitle CustomerReviewStyles AI-DescriptionStyles">
                            Discover how organizations and teams enhance asset visibility, boost compliance, and eliminate operational inefficiencies with Asset 365.


                        </p>
                        <div className="HR_MT">
                            <OurClients />
                        </div>
                    </div>
                    <div class="et-integration-section LMS_integration-section" >
                        <div style={{ width: "100%" }}>
                            <h2 class="et-integration-title lMS_integration-title" >
                                Powerful Integrations,<br /> Zero Platform Switching
                            </h2>
                            <p class="et-integration-subtitle lMS_integration-subtitle" >
                                Asset 365 is designed to work seamlessly within the Microsoft 365 ecosystem, integrating effortlessly with tools you already use, such as Microsoft Teams, SharePoint, and Outlook. It unifies all asset records and updates in one organized workspace, ensuring everything is easy to track, manage, and access for your team.
                            </p>
                            <span id="pricing" />
                        </div>
                        <div style={{ width: "61%", margin: "0", padding: "0vw", }}>
                            <img src="https://ik.imagekit.io/cubiclogics/giff%20file/AM/Asset-Management-withbg.gif" alt="" />
                            {/* <video
                                src="https://ik.imagekit.io/apps365/Apps365/LMS/LMS%20(1).mp4"
                                autoPlay
                                muted
                                loop
                                playsInline
                                style={{ width: "85%", borderRadius: "0.5vw" }}

                            /> */}

                        </div>

                        {/* <div class="LMS-integration-grid">
              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20Automate%20(1)_eXEyQVXbrh.png?updatedAt=1735914125187"
                  />{" "}
                </div>
                <h3 class="et-card-title">Power Automate</h3>
                <p class="et-card-description">
                  Save time by automating ticket updates, notifications, and
                  approvals for smoother support management.
                </p>
              </div>

              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20Bi%20(1)_Kds_Hz7QcQ.png?updatedAt=1735914124948"
                  />
                </div>
                
                <h3 class="et-card-title">Power BI</h3>
                <p class="et-card-description">
                  Generate clear and detailed reports to better analyse support
                  performance and make informed decisions.
                </p>
              </div>

              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/power%20apps%20(1)_fKJEyRsAdu.png?updatedAt=1735914124951"
                  />
                </div>
                <h3 class="et-card-title">Power Apps</h3>
                <p class="et-card-description">
                  Use AI chatbots to instantly answer common customer support
                  queries or provide ticket updates.
                </p>
              </div>

              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20virtual%20Agent%20(1)_F7DLaFcFoe.png?updatedAt=1735914125177"
                  />
                </div>
                <h3 class="et-card-title">Power Virtual Agent</h3>
                <p class="et-card-description">
                  Build custom apps to enhance ticketing workflows and integrate
                  seamlessly with LMS 365.
                </p>
              </div>
            </div> */}

                    </div>

                    <div id="integration" className="IdChangesIntegration"></div>

                    <div className="IdChanges"></div>
                    <div className="HR_whitesection" style={{ background: "none" }}>
                        <h2 className="HR_heading HR_MT" style={{ color: "#333", marginBottom: "0vw" }}>
                            Asset 365 Pricing & Plans
                        </h2>
                        <p className="AI-DescriptionStyles" style={{ margin: "0", marginBottom: "1vw" }}>
                            Flexible pricing designed for growing organizations and enterprises.

                        </p>
                        <div className="HR_MT">
                            <div>
                                <Plans appName={"Asset 365"} />
                            </div>
                        </div>
                    </div>
                    <div className="AzureBoxStyles_LMS">
                        <div className="AzureBoxStyles_LMS_1">
                            <img style={{ width: "66%" }} src="https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png" alt="" />
                            <h3 className="Azureheading" style={{ marginBottom: "0.8vw !important", paddingTop: "0.41vw" }}>Live on Azure</h3>
                            <p className="AzureText" style={{ textAlign: "center" }}>Buy directly from Azure Marketplace or via your enterprise agreement.</p>
                            <a className="Hr_Link" href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1">  Get started on Azure</a>
                        </div>
                        <div className="AzureBoxStyles_LMS_2" >

                            <img style={{ width: "65%" }} src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/Random-Images/Untitled%20design%20(21)_nD6tRPn1n9.png" alt="" />
                            <h3 className="Azureheading">Special Pricing for NPOs</h3>

                            <SpecailButtons userCount={"50+"} LMS365="LMS365" hideSpecialrequest="hideSpecialrequest" SpecailButtonsText="Non-profits and government-funded educational institutes can avail exclusive rates." />
                        </div>
                        <div className="AzureBoxStyles_LMS_3">

                            <img style={{ width: "40%" }} src="https://ik.imagekit.io/apps365/Apps365/HD/Untitled%20design%20(27).webp" alt="" />
                            <h3 className="Azureheading" style={{ marginBottom: "0.8vw !important", paddingTop: "0.3vw" }}>Enterprise Pricing for 50+ Users
                            </h3>

                            <SpecailButtons userCount={"50+"} LMS365="LMS365" hideNPOrequest="hideNPOrequest" SpecailButtonsTextUser="Organizations with more than 50 users can avail special pricing." />
                        </div>


                    </div>
                    {/* <div
            className="Azuersection"
            style={{
              background: "none",
              paddingBottom: "0vw",
              paddingTop: "0vw",
            }}
          >
            <div className="AzureLogoText">
              <a
                href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1"
                target="_blank"
              >
                <img
                  className="AzureImage"
                  src="https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png"
                  alt="Azure"
                />
              </a>
              <p className="AzureText">
                Using Azure? now you can{" "}
                <a
                  href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1"
                  target="_blank"
                >
                  buy
                </a>
                on Azure Marketplace or using your enterprise agreement
              </p>
            </div>
          </div> */}


                    <span className="privacytext"></span>
                    <div id="faq" className="IdChangesIntegration"></div>
                    <div class="et et-demo-section">
                        <h1 class="et et-demo-heading" style={{ margin: "0", padding: "0", color: "#333", paddingTop: "2vw" }}>
                            Take Full Control of Every Asset Your Organization Owns
                        </h1>
                        <p class="et et-demo-subtext AI-DescriptionStyles" style={{ marginBottom: "0" }}>
                            Asset 365 gives you a single source of truth for all your assets — tracked, assigned, and managed entirely within Microsoft 365. No new systems to adopt. Just complete visibility across every asset with full accountability from day one.
                        </p>
                        <p class="et et-demo-subtext AI-DescriptionStyles">
                            Book a live demo and see Asset 365 in action!
                        </p>
                        {/* <div class="et et-button-group">
              <DemoButtons
                hideDemoBtn="fasle"
                trailbtnText="Start Your 14-Day Free Trial button"
              />
            </div> */}
                        <form
                            id="lpgetstartedform"
                            className="lpgetstartedformclass "
                            style={{ padding: "2vw", background: "#f9faffbb", borderRadius: "0.5vw", paddingBottom: "0vw" }}
                        >
                            <div className="FooterContainer">
                                <div className="BottomFormleftimg">
                                    <img className="BottomFormImage" src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/LMS365/LMS365-bottom-form_V3Jq3dsZk.png" alt="" />
                                </div>
                                <div className="FieldsButtonStyles">
                                    <div className="FormFieldStyles">
                                        <h3>Book a Personalized Asset 365 Demo!</h3>
                                        <DemoButtons LMS365demoForm={true} />
                                    </div>
                                    {/* <div className="ButtonandPrivacyText">
                    <PrimaryButton
                      style={{ background: "var(--btn-bg-color)", border: "none", fontSize: "1.1vw" }}
                      id="lpgetstartedsubmitbutton"
                      className="subButton"
                    // onClick={() => submitRequest("getstarted")}
                    >
                      {"Select a Time Slot"}

                    </PrimaryButton>

                  </div> */}
                                </div>
                            </div>
                        </form>
                        <div>
                            <h3 className="HR_faq">Frequently Asked Questions</h3>
                            <Accordion items={accordionItems} />
                        </div>
                    </div>
                </div>
                <Footer ET365={"ET365"} />
            </HelmetProvider>
        </>
    );
}
export default Asset365;
